import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { MenuSection } from "@/components/site/MenuSection";
import { Gallery } from "@/components/site/Gallery";
import { ReservationSection } from "@/components/site/ReservationSection";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { MobileActionBar } from "@/components/site/MobileActionBar";

export default function Home() {
  return (
    <div data-testid="home-page" className="pt-[calc(4rem+env(safe-area-inset-top))] pb-20 md:pb-0">
      <Navbar />
      <Hero />
      <Marquee />
      <Manifesto />
      <Gallery />
      <MenuSection />
      <ReservationSection />
      <Footer />
      <WhatsAppFloat />
      <MobileActionBar />
    </div>
  );
}
